import type { PrefetchMode } from '@//hooks/useLinkPrefetch';
import { Link } from '../Link';
import styles from './LinkCloud.module.scss';

export interface LinkCloudItemProps {
  href: string;
  title: string;
  label: string;
  ariaLabel?: string;
  target?: string;
  rel?: string;
}

interface LinkCloudProps {
  links: LinkCloudItemProps[];
  testId: string;
  /** Prefetch policy applied to every link. Default 'none' — link clouds are
   *  typically low-CTR and shouldn't burn bandwidth on speculative prefetch. */
  prefetch?: PrefetchMode;
}

export const LinkCloud: React.FC<LinkCloudProps> = ({ links, testId, prefetch }) => (
  <ul className={styles.list} data-testid={testId}>
    {links.map((link, index) => (
      <li key={`link-cloud-${index}`} className={styles.item}>
        <Link
          href={link.href}
          title={link.title}
          ariaLabel={link.ariaLabel}
          target={link.target}
          rel={link.rel}
          prefetch={prefetch}
          className={styles.link}
          data-testid={`${testId}-link-${index + 1}`}
        >
          {link.label}
        </Link>
      </li>
    ))}
  </ul>
);
